import React from 'react';
import { ExitingPersistence, SlideIn } from '@atlaskit/motion';
import { Inline, xcss } from '@atlaskit/primitives';

export const ToolbarWrapper = ({ children }: { children: React.ReactNode }) => {
	return (
		<Inline xcss={floatingPositionerStyles} alignBlock="center" alignInline="center">
			<ExitingPersistence>
				<SlideIn enterFrom="bottom" fade="inout">
					{(slideInProps) => <div {...slideInProps}>{children}</div>}
				</SlideIn>
			</ExitingPersistence>
		</Inline>
	);
};

const floatingPositionerStyles = xcss({
	position: 'fixed',
	bottom: 'space.100',
	width: '100%',
	left: '0',
	zIndex: 'layer',
});
